import React, { useState } from "react";

export const CreateTask = ({ handleCreateTask }) => {
  const [newTask, setNewTask] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newTask) {
      return;
    }
    setNewTask(e.target.value);

    handleCreateTask(newTask);
    setNewTask([]);
  };

  return (
    <div>
      <form className="btn bg-primary-subtle" onSubmit={handleSubmit}>
        <h3>Create a Task</h3>
        <div className="form-control">
          <input
            type="text"
            value={newTask}
            onChange={(e) => setNewTask(e.target.value)}
          />
          <button type="submit" className="btn btn-primary m-1">
            Create
          </button>
        </div>
      </form>
    </div>
  );
};
